import { systemConstants } from "../constants";

/* eslint-disable func-style */
export const systemActions = {
  setCustomer,
  delCustomer,
  setUser,
  delUser,
  expandCatalogueItem,
  closeCatalogueItem,
  setHidePrice,
  setTab,
  setOffsetTop,
  toggleMinimizeUI,
  toggleMobileNavButton,
};

function setCustomer(model) {
  localStorage.setItem("customer", model.clientCode);
  return (dispatch) => {
    dispatch(update(model));
  };

  function update(model) {
    return { type: systemConstants.CUSTOMER_MODEL_UPDATE, payload: { model } };
  }
}

function delCustomer() {
  localStorage.removeItem("customer");
  return (dispatch) => {
    dispatch(del());
  };

  function del() {
    return { type: systemConstants.CUSTOMER_MODEL_DELETE };
  }
}

function setUser(model) {
  return (dispatch) => {
    dispatch(update(model));
  };

  function update(model) {
    return { type: systemConstants.USER_MODEL_UPDATE, payload: { model } };
  }
}

function delUser() {
  return (dispatch) => {
    dispatch(del());
  };

  function del() {
    return { type: systemConstants.USER_MODEL_DELETE };
  }
}

function expandCatalogueItem(id) {
  return (dispatch) => {
    dispatch(open(id));
  };

  function open(id) {
    return { type: systemConstants.CATALOGUE_SELECTION_OPEN, payload: { id } };
  }
}

function closeCatalogueItem() {
  return (dispatch) => {
    dispatch(close());
  };

  function close() {
    return { type: systemConstants.CATALOGUE_SELECTION_CLOSE };
  }
}

function setHidePrice(hidden) {
  return (dispatch) => {
    dispatch(hide(hidden));
  };

  function hide(hidePrice) {
    return { type: systemConstants.HIDE_PRICE, payload: { hidePrice } };
  }
}

function setTab(tab) {
  return (dispatch) => {
    dispatch(set(tab));
  };

  function set(tab) {
    return { type: systemConstants.TAB, payload: { tab } };
  }
}

function setOffsetTop(offset) {
  return { type: systemConstants.SET_OFFSET_TOP, payload: offset };
}

function toggleMinimizeUI(toggle) {
  return { type: systemConstants.MINIMIZE_UI, payload: toggle };
}

function toggleMobileNavButton(button) {
  return { type: systemConstants.TOGGLE_MOBILE_NAV_BUTTON, payload: button };
}
